import { Pipe, PipeTransform } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { CatalogData } from '../providers/catalog';

@Pipe({
  name: 'catalogRank'
})

export class CatalogRankPipe implements PipeTransform {

  constructor(
    private catalogData: CatalogData
  ) { }

  transform(catalogId: string): Observable<any> {
    return this.catalogData.getCatalogRankById(catalogId);
  }
}


// WEBPACK FOOTER //
// ./src/pipes/catalog-rank.pipe.ts